export default __webpack_public_path__ + "static/media/excess_brightness.ba4b2f93.svg";